angular.module('mean.projects').controller('ProjectScheduleAdminController', ['$scope', 'Global', 'Projects', '$q', 'MeanUser', 'Users', '$filter', '$http', 'Holidays', '$timeout', 'ProjectTasks', 'taskListService', 'tradeCodeService', 'lotTaskDataService', '$rootScope',
  function($scope, Global, Projects, $q, MeanUser, Users, $filter, $http, Holidays, $timeout, ProjectTasks, taskListService, tradeCodeService, lotTaskDataService, $rootScope) {
    $scope.global = Global;
    $scope.package = {
      name: 'projectScheduleAdmin'
    };

    if($scope.selectedItem)
      console.log('selected project ' + $scope.selectedItem.name);

    $scope.init = function() {
        taskListService.get($scope.selectedItem.projectType, $scope.selectedItem.geoLocation).then(function(results) {
            $scope.gtasks = $filter('orderBy')(results, 'order', false);
        });

        $scope.current_trades = tradeCodeService.getArray();
    };

    $scope.$on("projectSelectionUpdated", function (args) {
        // This gets called more than once.  I could not find
        // the problem but it will need to be addressed.
        if(!$scope.$parent.selectedItem) return;

        $scope.selectedItem = $scope.$parent.selectedItem;
        //console.log($scope.selectedItem.name);
        //$scope.submit();
    });

    $scope.submit = function() {
        if(!$scope.selectedItem) {
           console.log('selectedItem is null...returning.');
           return;
        }

        $scope.updatePhaseList();
        $scope.changePhase();
        
        ProjectTasks.query({'project_id': $scope.selectedItem._id, 'complete': false}, function(tasks) {
            $scope.ordered_lots = $filter('orderBy')($scope.selectedItem.lots, ['phase', 'number'], false);
            $scope.project_tasks = tasks;
            $scope.updateTable();
        });
    };

    $scope.updatePhaseList = function() {
        $scope.current_phases = [];

        $scope.selectedItem.lots.forEach(function(lot) {
            var inlist = $filter('filter')($scope.current_phases, {'name': lot.phase}, true);

            if(inlist.length === 0) {
                $scope.current_phases.push({
                    name: lot.phase
                });
            }
        });
    };

    $scope.changePhase = function(selectedPhase) {
        $scope.selectedPhase = selectedPhase;
        console.log('$scope.changePhase called');

        $scope.lots = [];

        var lots = [];
        if(selectedPhase)
            lots = $filter('filter')($scope.selectedItem.lots, {'phase': selectedPhase.name}, true);
        else
            lots = $scope.selectedItem.lots

        lots.forEach(function(lot) {
            var inlist = $filter('filter')($scope.lots, {'name': lot.number}, true);

            if(inlist.length === 0) {
                $scope.lots.push({
                    name: lot.number
                });
            }
        });
    };

    $scope.changeLot = function(selectedLot) {
        $scope.selectedLot = selectedLot;
    };

    $scope.changeTrade = function(selectedTrade) {
        $scope.selectedTrade = selectedTrade;
    };

    $scope.changeTask = function(selectedTask) {
        $scope.selectedTask = selectedTask;
    };

    $scope.updateTable = function() {
        $scope.schedule_data = [];
        var col_data = [];

        $scope.gtasks.forEach(function(main_task) {
            col_data = [];
            $scope.ordered_lots.forEach(function(lot) {
                var task_data = $filter('filter')($scope.project_tasks, {
                    'lot': lot.number, 'task_name': main_task.task_name}, true);

                if(task_data.length === 0) return;
                
                var start = moment(task_data[0].start_date);
                var now = moment();

                var result;

                if(start.dayOfYear() === now.dayOfYear()) {
                    if(task_data[0].status === 'on_track')
                      result = 0;
                    else if(task_data[0].status === 'finished')
                      result = 1;
                    else if(task_data[0].status === 'delayed_start') //the system will set delayed_start automatically on same date
                      result = -1;
                    console.log('Task ' + task_data[0].task_name + ' is scheduled for today');
                } else if(start < now && task_data[0].status !== 'finished') {
                    result = -1;
                } else if(start < now && task_data[0].status === 'finished') {
                    result = 1;
                }

                var cloud;
                var check;
                var times;
                for(var i=0; i<task_data[0].prior_start_dates.length; i=i+1) {
                    if(task_data[0].prior_start_dates[i].reason === 'Weather') {
                        cloud = true;
                    }
                    if(task_data[0].prior_start_dates[i].reason === 'Did Not Finish' ||
                        task_data[0].prior_start_dates[i].reason === 'No Show') {
                        times = true;
                    }
                    if(task_data[0].prior_start_dates[i].reason === 'Finished Early' ||
                        task_data[0].prior_start_dates[i].reason === 'Site Not Ready') {
                        check = true;
                    }
                }

                //We don't need all the data from the task
                var new_data = {
                    task_name: task_data[0].task_name,
                    lot: task_data[0].lot,
                    phase: task_data[0].phase,
                    start_date: task_data[0].start_date,
                    prior_start_dates: task_data[0].prior_start_dates,
                    status: task_data[0].status,
                    trade: task_data[0].trade,
                    result: result,
                    cloud: cloud,
                    times: times,
                    check: check
                };
                col_data.push(new_data);
            });
            $scope.schedule_data.push(col_data);
        });
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/controllers/projectSchedule.js